import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Login from "./Components/Login";
import Signup from "./Components/Signup";
import ProtectedRoute from "./Components/ProtectedRoute";
import {ChatContextProvider} from "./context/chatContext";
import HomePage from "./Pages/HomePage";
import CreateProductPage from "./Pages/CreateProductPage";
import BulkUploadPage from "./Pages/BulkUploadPage";
import WooCommerceCredentialsPage from "./Pages/WooCommerceCredentialsPage";
import LocalProductsPage from "./Pages/LocalProductsPage";
import UserView from "./Pages/UserView";
import UpdateDescriptionsPage from "./Pages/UpdateDescriptionsPage";
import WooCommerceUploadPage from "./Pages/WooCommerceUploadPage";

function App() {
    return (
        <ChatContextProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<Login/>}/>
                    <Route path="/Signup" element={<Signup/>}/>

                    <Route path="/HomePage" element={
                        <ProtectedRoute>
                            <HomePage/>
                        </ProtectedRoute>

                    }/>
                    <Route path="/Product" element={
                        <ProtectedRoute>
                            <CreateProductPage/>
                        </ProtectedRoute>
                    }/>

                    <Route path="/Upload" element={
                        <ProtectedRoute>
                            <BulkUploadPage/>
                        </ProtectedRoute>
                    }/>
                    <Route path="/Setting" element={
                        <ProtectedRoute>
                            <WooCommerceCredentialsPage/>
                        </ProtectedRoute>
                    }/>

                    <Route path="/Users" element={
                        <ProtectedRoute>
                            <UserView/>
                        </ProtectedRoute>
                    }/>

                    <Route path="/Manage" element={
                        <ProtectedRoute>
                            <LocalProductsPage/>
                        </ProtectedRoute>
                    }/>


                    <Route path="/Update" element={
                        <ProtectedRoute>
                            <UpdateDescriptionsPage/>
                        </ProtectedRoute>
                    }/>


                    <Route path="/UploadProducts" element={
                        <ProtectedRoute>
                            <WooCommerceUploadPage/>
                        </ProtectedRoute>
                    }/>
                    {/* <Route path="/Missing" element={*/}
                    {/*    <ProtectedRoute>*/}
                    {/*        <MissingProductsPage/>*/}
                    {/*    </ProtectedRoute>*/}
                    {/*}/>*/}


                </Routes>
            </Router>
        </ChatContextProvider>
    );
}

export default App;
